<template>
  <BlockContainer class="p-5">
    <h2>Inviter leietaker til å kjøpe depositumsgaranti</h2>

    <div class="my-4">
      <p>
        For å invitere leietaker til å kjøpe depositumsgaranti må du først velge hvilken verdi depositumet skal være på.
        Når du har klikket “send” så får leietaker en e-post med oppfordring om å kjøpe depositumsgaranti på Husleie.no
      </p>
    </div>

    <div class="my-5">
      <h5>Velg depositumsgarantiens størrelse</h5>

      <!-- Number of months for deposit -->
      <div class="row row-equal-height mt-5 mb-5">
        <div class="col-12 col-md-6 text-left">
          <div class="box-container">
            <p class="font-weight-bold">{{ isOwnDefined ? 'Egendefinert beløp' : 'Antall måneder depositum' }}</p>
            <div v-if="!isOwnDefined">
              <div class="row months mt-5">
                <div class="col">
                  <hl-RadioButtonTapWithIcon v-model="months" radioValue="1" layout="vertical" iconClass="none">
                    <p>1</p>
                  </hl-RadioButtonTapWithIcon>
                </div>
                <div class="col">
                  <hl-RadioButtonTapWithIcon v-model="months" radioValue="2" layout="vertical" iconClass="none">
                    <p>2</p>
                  </hl-RadioButtonTapWithIcon>
                </div>
                <div class="col">
                  <hl-RadioButtonTapWithIcon v-model="months" radioValue="3" layout="vertical" iconClass="none">
                    <p>3</p>
                  </hl-RadioButtonTapWithIcon>
                </div>
              </div>

              <div class="row months mt-4">
                <div class="col">
                  <hl-RadioButtonTapWithIcon v-model="months" radioValue="4" layout="vertical" iconClass="none">
                    <p>4</p>
                  </hl-RadioButtonTapWithIcon>
                </div>
                <div class="col">
                  <hl-RadioButtonTapWithIcon v-model="months" radioValue="5" layout="vertical" iconClass="none">
                    <p>5</p>
                  </hl-RadioButtonTapWithIcon>
                </div>
                <div class="col">
                  <hl-RadioButtonTapWithIcon v-model="months" radioValue="6" layout="vertical" iconClass="none">
                    <p>6</p>
                  </hl-RadioButtonTapWithIcon>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col">
                <hl-Checkbox label="Egendefinert beløp" v-model="isOwnDefined"></hl-Checkbox>
              </div>
            </div>

            <div v-if="isOwnDefined" class="row mt-4">
              <div class="col">
                <hl-Input
                  v-model="ownDefined"
                  placeholder="Ditt egen depositumsbeløp"
                  label="Beløp"
                  name="deposit.ownDefinedAmount"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 mt-4 mt-md-0 text-left">
          <div class="box-container bg-light h-100">
            <p v-if="!isOwnDefined" class="font-weight-bold">Kalkulert depositumsbeløp</p>
            <p v-else class="font-weight-bold">Egendefinert depositumsbeløp</p>
            <div class="text-center mt-5">
              <i class="budicon-savings" style="font-size: 3em"></i>
              <h5 class="mt-3">
                {{ isOwnDefined ? ownDefined : depositAmount | toCurrency }}
              </h5>

              <span v-if="isOwnDefined">Egendefinert</span>
            </div>
          </div>
        </div>
      </div>
      <!-- / Number of months for deposit -->
    </div>

    <div class="my-5">
      <h5>Valgfritt?</h5>

      <p class="mt-4">Skal det være valgfritt for leietaker å kjøpe depositumsgaranti?</p>

      <hl-SwitchWithLabels
        class="mt-4 switch"
        showState
        onState="Ja"
        offState="Nei"
        :value="isOptional"
        @input.native="setOptional"
      ></hl-SwitchWithLabels>
    </div>

    <div class="mt-5 pt-5">
      <router-link :to="{ name: 'tenancy_new_deposit_guarantee_success' }">
        <button class="btn btn-primary mx-2">Send</button>
      </router-link>
      <router-link :to="{ name: 'tenancy_deposit' }">
        <button class="btn btn-outline-secondary mx-2">Avbryt</button>
      </router-link>
    </div>
  </BlockContainer>
</template>

<script>
import BlockContainer from '@/components/BlockContainer';
import { mapGetters } from 'vuex';
import RadioButtonTapWithIcon from '@modules/husleie-framework/src/components/forms/inputs/radio-buttons/RadioButtonTapWithIcon.vue';
import Checkbox from '@modules/husleie-framework/src/components/forms/inputs/checkbox/Checkbox.vue';
import Input from '@modules/husleie-framework/src/components/forms/inputs/input/Input.vue';
import SwitchWithLabels from '@modules/husleie-framework/src/components/forms/inputs/switch/SwitchWithLabels.vue';

export default {
  components: {
    BlockContainer,
    'hl-RadioButtonTapWithIcon': RadioButtonTapWithIcon,
    'hl-Checkbox': Checkbox,
    'hl-Input': Input,
    'hl-SwitchWithLabels': SwitchWithLabels,
  },

  data() {
    return {
      isOptional: false,
      isOwnDefined: false,
      ownDefined: null,
      months: '3',
    };
  },

  computed: {
    ...mapGetters('tenancy', ['getTenancy']),
    depositAmount() {
      if (this.isOwnDefined) {
        return 9;
      }
      if (this.getTenancy) {
        const months = parseInt(this.months, 10);
        return this.getTenancy.rent.rent * months;
      }
      return 0;
    },
  },

  methods: {
    setOptional(e) {
      this.isOptional = e.target;
    },
  },
};
</script>

<style lang="scss" scoped>
.switch {
  max-width: 200px;
}

.box-container {
  border: 1px solid $gray-400;
  padding: 30px;
  border-radius: $border-radius;
}
</style>
